import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import "./productosScreen.less";

import Card from "./Card/card";
import LoadingBox from "../../Component/LoadingBox";
import MessageBox from "../../Component/MessageBox";
import { listProducts } from "../../redux/actions/productActions";

export default function ProductsScreenTecnologia() {
  interface Product {
    imagen: string | string[];
    name: string;
    ArticleNumber: string;
    rating: number;
    numReviews: number;
    price: number;
  }

  const dispatch = useDispatch();
  const productsList = useSelector((state: any) => state.productList);
  const { loading, error, products } = productsList;
  //console.log("ProductsScreen products", products);

  useEffect(() => {
    dispatch(listProducts("tecnologia-hogar"));
  }, []);

  return (
    <section className="productos">
      <h1 className="title"> ¿Qué tipo de equipo busca?</h1>
      {loading ? (
        <LoadingBox></LoadingBox>
      ) : error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        // *** CAMBIO AQUÍ: Usamos un div con la clase cards-container ***
        <div className="cards-container ">
          {Array.isArray(products) && products.length > 0 ? (
            products.map((product) => (
              <Card
                key={product.ArticleNumber}
                id={product._id}
                imagen={product.imagen}
                name={product.name}
                articulo={product.ArticleNumber}
                rating={product.rating}
                numReviews={product.numReviews}
                price={product.price}
              />
            ))
          ) : (
            <p>No products available</p>
          )}
        </div>
      )}
    </section>
  );
}
